import errorSVG from "src/assets/error.svg";
import Button from "../ui/button.component";

const ErrorInFile = ({ errors, url }: { errors: number; url: string }) => {
  function downloadCSV() {
    const link = document.createElement("a");
    link.href = url;
    link.download = "Invalid.csv";
    link.click();
  }
  return (
    <div className="flex items-center justify-between px-[12px] py-[8px] relative bg-red-50 rounded-[8px] border border-solid border-red-200">
      <div className="inline-flex items-center gap-[6px] relative flex-[0_0_auto]">
        <img className="relative w-[20px] h-[20px]" alt="Error" src={errorSVG} />
        <div className="relative w-fit [font-family:'Inter-Medium',Helvetica] font-medium text-red-600 text-[14px] tracking-[-0.14px] leading-[normal] whitespace-nowrap">
          {errors} errors found!
        </div>
      </div>
      <Button
        onClick={downloadCSV}
        className="relative inline-flex items-center gap-[6px] px-[8px] py-[4px] bg-red-100 text-red-600 border border-solid border-red-200 rounded-[4px]"
      >
        Download
      </Button>
    </div>
  );
};

export default ErrorInFile;
